import React, { useEffect, useState } from 'react'
import { IoMdArrowBack, IoMdClose } from 'react-icons/io'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaCircleChevronRight, FaRegCircleCheck, FaRightLong } from "react-icons/fa6";
import { FaRegCircleXmark } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import tickIcon from "../../assets/svg/Tick Square.svg"
import closeIcon from "../../assets/svg/Close Square.svg"
import { approveOrder, deleteOrderProduct, downloadCustomerOrderInvoice, downloadVendorOrderInvoice, exchangeorRejectOrder, getOrderDetails, rejectOrder, shipOrder } from '../../api/context/orders';
import moment from 'moment';
import { Col, Modal, Row, Spinner, Table, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FaDownload } from "react-icons/fa6";
import Loader from '../../components/loader/loader';
import { AiOutlineDeliveredProcedure } from "react-icons/ai";
import { FaRegCopy } from "react-icons/fa6";
import { getBaseUrl } from '../../helpers/helper';
import { checkUserPermissions } from "../../helpers/permission";


import {
    FaRegCalendarAlt,
    FaMoneyBillWave,
    FaCreditCard,
    FaCheckCircle,
    FaTimesCircle,
    FaTruck,
    FaBoxOpen,
    FaShippingFast,
    FaExchangeAlt,
    FaMapMarkerAlt
} from 'react-icons/fa';
import { FiImage, FiRefreshCw } from 'react-icons/fi';
import { BsImageAlt } from 'react-icons/bs';
import ErrorState from '../../components/Error/errorState';

const customStyles = `
  .custom-rounded {
    border-radius: 8px 8px 8px 8px !important;
  }
  .custom-rounded-card {
    border-radius: 12px 12px 12px 12px !important;
    border: 1px solid #dee2e6 !important;
  }
  .custom-rounded-img {
    border-radius: 4px 4px 4px 4px !important;
  }
  .custom-rounded-btn {
    border-radius: 4px 4px 4px 4px !important;
  }
  .custom-rounded-modal .modal-content {
    border-radius:  12px 12px 12px 12px !important;
    border: none !important;
  }
  .custom-rounded-table {
    border-radius: 8px 8px 8px 8px !important;
    overflow: hidden;
  }
  .custom-rounded-table th:first-child,
  .custom-rounded-table td:first-child {
    border-left: none;
  }
  .custom-rounded-table th:last-child,
  .custom-rounded-table td:last-child {
    border-right: none;
  }
  .otp-container .order-otp {
    border-radius: 4px 4px 4px 4px !important;
  }
  .color-code {
    border-radius: 50% 50% 50% 50% !important;
  }
  .vertical-divider {
    border-left: 1px solid #dee2e6;
    height: 100%;
  }
`;

const OrderDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;
    const { id } = useParams();

    const [orderId, setOrderID] = useState([id]);
    const [orderIdSingle, setOrderIDSingle] = useState(id);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [update, setUpdate] = useState(false)
    const [orderData, setOrderData] = useState([]);
    const [downloadVendorInvoice, setDownloadVendorInvoice] = useState(false)
    const [downloadCustomerInvoice, setDownloadCustomerInvoice] = useState(false)
    const [showOrder, setShowOrder] = useState(false);
    const [orderItem, setOrderItem] = useState({
        id: "",
        type: "",
        status: "",
        orderItemProducts: ""
    });

    const [stickyVideo, setStickyVideo] = useState(null);
    const [showEvidenceModal, setShowEvidenceModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [customReason, setCustomReason] = useState('');


    const handleRefresh = () => {
        setError(false);
        setRefreshing(true);
        setLoading(true);

        // Refresh all order-related data
        getOrderDetails(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setOrderData(response?.data?.data?.[0]);

                // If it's a return/exchange order, refresh evidence video
                if (response?.data?.data?.[0]?.orderType === 1 || response?.data?.data?.[0]?.orderType === 2) {
                    const videoUrl = getEvidenceVideoUrl();
                    if (videoUrl && !stickyVideo) {
                        const orderType = response?.data?.data?.[0]?.orderType === 1 ? 'Return' :
                            response?.data?.data?.[0]?.orderType === 2 ? 'Exchange' : 'Evidence';
                        setStickyVideo({
                            url: videoUrl,
                            type: orderType,
                            returnId: response?.data?.data?.[0]?.id
                        });
                    }
                }

                toast.success('Order details refreshed successfully!');
            } else {
                toast.error('Failed to refresh order details');
                setOrderData([]);
                setError(true);
            }
            setRefreshing(false);
            setLoading(false);
        });
    };

    // Rejection reasons
    const rejectionReasons = [
        "Product damaged by customer",
        "Wrong product returned",
        "Return period expired",
        "Missing original packaging",
        "Product used/worn",
    ];


    const handleEvidenceModalShow = () => {
        setShowEvidenceModal(true);
        setRejectionReason('');
        setCustomReason('');
    }

    const handleEvidenceModalClose = () => {
        setShowEvidenceModal(false);
        setRejectionReason('');
        setCustomReason('');
    }

    const handleRejectOrder = () => {
        // If no dropdown reason selected but custom reason has sufficient text
        if (!rejectionReason && customReason && customReason.trim().length >= 10) {
            // Use the custom reason directly
            const finalReason = customReason;

            setLoading(true);
            rejectOrder({
                orderIds: [id],
                reason: finalReason
            })((response) => {
                if (response?.data?.statusCode == 200) {
                    toast.success(response?.data?.message ? response?.data?.message : "Order rejected successfully", 'success');
                    navigate('/orders');
                } else {
                    toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error');
                    setLoading(false);
                }
            });
            return;
        }

        // Original logic for dropdown selection
        if (!rejectionReason) {
            toast.error("Please select a reason for rejection or provide a custom reason");
            return;
        }

        if (rejectionReason === "Other (specify below)" && !customReason.trim()) {
            toast.error("Please specify the reason for rejection");
            return;
        }

        const finalReason = rejectionReason === "Other (specify below)" ? customReason : rejectionReason;

        setLoading(true);
        rejectOrder({
            orderIds: [id],
            reason: finalReason
        })((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order rejected successfully", 'success');
                navigate('/orders');
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error');
                setLoading(false);
            }
        });
    };

    // Get evidence video URL
    // Get evidence video URL - Updated version
    const getEvidenceVideoUrl = () => {
        // Check current order's orderProducts first
        if (orderData && orderData.orderProducts) {
            const allReturns = orderData.orderProducts.flatMap(product =>
                product.returns || []
            );

            const returnsWithVideos = allReturns.filter(returnItem =>
                returnItem.returnImages && returnItem.returnImages.length > 0
            );

            if (returnsWithVideos.length > 0) {
                const firstReturnWithVideo = returnsWithVideos[0];
                const videoImage = firstReturnWithVideo.returnImages.find(img =>
                    img.mediaType === 'video'
                );
                return videoImage?.mediaUrl;
            }
        }

        // If not found in current order, check baseOrder
        if (orderData && orderData.baseOrder && orderData.baseOrder.orderProducts) {
            const baseOrderReturns = orderData.baseOrder.orderProducts.flatMap(product =>
                product.returns || []
            );

            const baseReturnsWithVideos = baseOrderReturns.filter(returnItem =>
                returnItem.returnImages && returnItem.returnImages.length > 0
            );

            if (baseReturnsWithVideos.length > 0) {
                const firstReturnWithVideo = baseReturnsWithVideos[0];
                const videoImage = firstReturnWithVideo.returnImages.find(img =>
                    img.mediaType === 'video'
                );
                return videoImage?.mediaUrl;
            }
        }

        return null;
    };

    const evidenceVideoUrl = getEvidenceVideoUrl();


    const otp = state?.otp || [1, 2, 3, 4];

    const handleOrderShow = (orderitem) => {
        setShowOrder(true);
        setOrderItem({ id: orderitem?.returns?.[0]?.id, type: orderitem?.returns?.[0]?.type, status: orderitem?.returns?.[0]?.status, orderItemProducts: orderitem })
    }

    const renderOtpDigits = (otp) => {
        if (!otp) return null;
        const digits = otp.toString().split('');
        return digits.map((digit, index) => (
            <div key={index} className='order-otp bg-light border p-2 mx-1'>{digit}</div>
        ));
    };

    const handleCloseOrder = () => {
        setShowOrder(false);
    };

    const copyToClipBoard = () => {
        const table = document.querySelector('.delivery-details-table');
        if (!table) return;
        const rows = table.querySelectorAll('tr');
        let formattedText = "";
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            let rowText = [];
            cells.forEach(cell => {
                rowText.push(cell.textContent.trim());
            });
            formattedText += rowText.join(': ') + "\n";
        });

        navigator.clipboard.writeText(formattedText).then(() => {
            toast.success("Order details copied");
        }).catch(err => console.error('Failed to copy: ', err));
    };

    const handleOrderStatusChange = (status, successMessage) => {
        setLoading(true);
        approveOrder({ orderIds: [id], status })((response) => {
            if (response?.data?.statusCode === 200) {
                toast.success(response?.data?.message || successMessage, 'success');
                navigate('/orders')
            } else {
                toast.error(response?.data?.message || "Something went wrong", 'error');
            }
            setLoading(false);
        });
    };

    const handleApproveOrder = () => {
        handleOrderStatusChange("CONFIRMED", "Order accepted successfully");
    };

    const handleMarkAsDelivered = () => {
        handleOrderStatusChange("DELIVERED", "Order marked as delivered successfully");
    };

    const handleCancelOrder = () => {
        setLoading(true)
        rejectOrder({ orderIds: [id] })((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order cancelled successfully", 'success')
                navigate('/orders')
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setLoading(false)
            }
        })
    }

    const cancelProductOrder = (id) => {
        deleteOrderProduct(id)((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Product deleted successfully", 'success')
                setUpdate(!update)
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setUpdate(!update)
            }
        })
    }

    const handleShipOrder = () => {
        setLoading(true)
        shipOrder({ orderId: [id] })((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order added successfully", 'success')
                setUpdate(!update)
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setLoading(false)
            }
        })
    }

    const handleDownloadVendorInvoice = () => {
        setDownloadVendorInvoice(true);

        downloadVendorOrderInvoice({
            responseType: 'blob',
            params: { orderId: orderIdSingle }
        })((response) => {
            try {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `invoice-ord${orderIdSingle}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                toast.error("Failed to download invoice");
            } finally {
                setDownloadVendorInvoice(false);
            }
        });
    };

    const handleDownloadCustomerInvoice = () => {
        setDownloadCustomerInvoice(true);

        downloadCustomerOrderInvoice({
            responseType: 'blob',
            params: { orderId: orderIdSingle }
        })((response) => {
            try {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `invoice-ord${orderIdSingle}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                toast.error("Failed to download invoice");
            } finally {
                setDownloadCustomerInvoice(false);
            }
        });
    };

    const handleOrderReturnExchange = (id, status) => {
        setLoading(true);
        exchangeorRejectOrder({ id, status })((response) => {
            if (response?.data?.status) {
                toast.success(response?.data?.message);
                setUpdate(prevUpdate => !prevUpdate);
                setShowOrder(false)
            } else {
                toast.error(response?.data?.message || "Something went wrong", 'error');
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        if (id) {
            setLoading(true)
            getOrderDetails(id)((response) => {
                if (response?.data?.statusCode == 200) {
                    setOrderData(response?.data?.data?.[0]);
                    setLoading(false)
                } else {
                    setOrderData([])
                    setError(true);
                    setLoading(false)
                }
            })
        }
    }, [id]);

    // Auto-detect and show video when order data loads with returns/exchanges
    useEffect(() => {
        if (orderData) {
            const videoUrl = getEvidenceVideoUrl();

            if (videoUrl && !stickyVideo) {
                // Determine the type from orderData
                const orderType = orderData.orderType === 1 ? 'Return' :
                    orderData.orderType === 2 ? 'Exchange' : 'Evidence';

                setStickyVideo({
                    url: videoUrl,
                    type: orderType,
                    // You might need to adjust how you get the returnId
                    returnId: orderData.id // or appropriate ID
                });
            }
        }
    }, [orderData, stickyVideo]);

    const NotMaskedUserData = () => (
        <Table bordered className="custom-rounded-table">
            <tbody>
                <tr>
                    <td className='user-details-subheading'>User Name:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerName ? orderData.Address.customerName : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Mobile Number:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Email Address:</td>
                    <td className='user-details-data'>{orderData?.Address?.customerEmail ? `${orderData?.Address?.customerEmail}` : 'N/A'}</td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Address: </td>
                    <td className='user-details-data'>
                        <div className='user-details-address'>{orderData?.Address?.line1 + ',' + orderData?.Address?.line2 + "," + orderData?.Address?.locality}</div>
                        <div className='user-details-address'>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + 'Pincode:' + orderData?.Address?.postalCode}</div></td>
                </tr>
            </tbody>
        </Table>);

    const MaskedUserData = () => (
        <Table bordered className="custom-rounded-table">
            <tbody>
                <tr>
                    <td className='user-details-subheading'>User Name:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerName ? `${orderData.Address.customerName.charAt(0) + "****"}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Mobile Number:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile.slice(0, 3) + `*******`}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Email Address:</td>
                    <td className='user-details-data'>{orderData?.Address?.customerEmail ? `${orderData?.Address?.customerEmail.slice(0, 3) + `****@gmail.com`}` : '*****@gmail.com'}</td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Address: </td>
                    <td className='user-details-data'>
                        <div>{orderData?.Address?.line1 + ',' + orderData?.Address?.line2 + "," + orderData?.Address?.locality}</div>
                        <div>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + 'Pincode:' + orderData?.Address?.postalCode}</div>
                    </td>
                </tr>
            </tbody>
        </Table>);

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;


    const OrderStatusTracker = ({ status, type, paymentMode, paymentStatus, pidgeOrder }) => {
        // Updated color palette with more professional colors
        const statusColors = {
            INITIATED: '#6B7280',  // Gray
            ONLINE: '#10B981',     // Emerald
            CONFIRMED: '#3B82F6',   // Blue
            DELIVERED: '#10B981',   // Emerald
            REJECTED: '#EF4444',    // Red
            CANCELLED: '#EF4444',   // Red
            COD: '#06B6D4',         // Cyan
            PENDING: '#F59E0B',     // Amber
            OUT_FOR_PICKUP: '#F97316', // Orange
            REACHED_PICKUP: '#F59E0B', // Amber (similar to PENDING)
            PICKED_UP: '#14B8A6',   // Teal
            OUT_FOR_DELIVERY: '#8B5CF6', // Violet
            REACHED_DELIVERY: '#8B5CF6', // Violet (similar to OUT_FOR_DELIVERY)
        };

        const isReturnOrder = type === 1;

        const getSteps = () => {
            // Base steps for all order types
            let steps = [
                {
                    id: 1,
                    name: isReturnOrder ? 'Return Placed' : 'Order Placed',
                    statuses: ['INITIATED'],
                    color: statusColors.INITIATED,
                    icon: <FaRegCalendarAlt size={9} />,
                    completedIcon: <FaRegCalendarAlt size={9} className="text-white" />,
                    activeIcon: <FaRegCalendarAlt size={9} className="text-white" />
                },
                // Skip payment step for return orders
                ...(isReturnOrder ? [] : [{
                    id: 2,
                    name: paymentMode === 'COD'
                        ? paymentStatus === 'PENDING'
                            ? 'Pending Payment'
                            : 'Cash on Delivery'
                        : paymentStatus === 'DONE'
                            ? 'Online Paid'
                            : 'Payment Pending',
                    statuses: ['CONFIRMED', 'REJECTED', 'CANCELLED', 'DELIVERED'],
                    color: paymentMode === 'COD'
                        ? paymentStatus === 'PENDING'
                            ? statusColors.PENDING
                            : statusColors.COD
                        : paymentStatus === 'DONE'
                            ? statusColors.ONLINE
                            : statusColors.PENDING,
                    icon: paymentMode === 'COD'
                        ? <FaMoneyBillWave size={9} />
                        : <FaCreditCard size={9} />,
                    completedIcon: paymentMode === 'COD'
                        ? <FaMoneyBillWave size={9} className="text-white" />
                        : <FaCreditCard size={9} className="text-white" />,
                    activeIcon: paymentMode === 'COD'
                        ? <FaMoneyBillWave size={9} className="text-white" />
                        : <FaCreditCard size={9} className="text-white" />
                }]),
                {
                    id: isReturnOrder ? 2 : 3,
                    name: isReturnOrder
                        ? status === 'REJECTED' ? 'Return Rejected'
                            : status === 'CANCELLED' ? 'Return Cancelled'
                                : 'Return Confirmed'
                        : status === 'REJECTED' ? 'Order Rejected'
                            : status === 'CANCELLED' ? 'Order Cancelled'
                                : 'Order Confirmed',
                    statuses: ['CONFIRMED', 'REJECTED', 'CANCELLED'],
                    color: status === 'REJECTED' || status === 'CANCELLED' ?
                        statusColors.REJECTED : statusColors.CONFIRMED,
                    icon: status === 'REJECTED' || status === 'CANCELLED'
                        ? <FaTimesCircle size={9} />
                        : <FaCheckCircle size={9} />,
                    completedIcon: status === 'REJECTED' || status === 'CANCELLED' ?
                        <FaTimesCircle size={9} className="text-white" /> :
                        <FaCheckCircle size={9} className="text-white" />,
                    activeIcon: status === 'REJECTED' || status === 'CANCELLED' ?
                        <FaTimesCircle size={9} className="text-white" /> :
                        <FaCheckCircle size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 3 : 4,
                    name: isReturnOrder ? 'Return Picked Up' : 'Out for Pickup',
                    statuses: ['OUT_FOR_PICKUP'],
                    color: statusColors.OUT_FOR_PICKUP,
                    icon: <FaTruck size={9} />,
                    completedIcon: <FaTruck size={9} className="text-white" />,
                    activeIcon: <FaTruck size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 4 : 5,
                    name: isReturnOrder ? 'Reached Pickup' : 'Reached Pickup',
                    statuses: ['REACHED_PICKUP'],
                    color: statusColors.REACHED_PICKUP,
                    icon: <FaMapMarkerAlt size={9} />,
                    completedIcon: <FaMapMarkerAlt size={9} className="text-white" />,
                    activeIcon: <FaMapMarkerAlt size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 5 : 6,
                    name: isReturnOrder ? 'Return Processed' : 'Order Picked',
                    statuses: ['PICKED_UP'],
                    color: statusColors.PICKED_UP,
                    icon: <FaBoxOpen size={9} />,
                    completedIcon: <FaBoxOpen size={9} className="text-white" />,
                    activeIcon: <FaBoxOpen size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 6 : 7,
                    name: isReturnOrder ? 'Return Shipped' : 'Out for Delivery',
                    statuses: ['OUT_FOR_DELIVERY'],
                    color: statusColors.OUT_FOR_DELIVERY,
                    icon: <FaShippingFast size={9} />,
                    completedIcon: <FaShippingFast size={9} className="text-white" />,
                    activeIcon: <FaShippingFast size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 7 : 8,
                    name: isReturnOrder ? 'Reached Delivery' : 'Reached Delivery',
                    statuses: ['REACHED_DELIVERY'],
                    color: statusColors.REACHED_DELIVERY,
                    icon: <FaMapMarkerAlt size={9} />,
                    completedIcon: <FaMapMarkerAlt size={9} className="text-white" />,
                    activeIcon: <FaMapMarkerAlt size={9} className="text-white" />
                },
                {
                    id: isReturnOrder ? 8 : 9,
                    name: isReturnOrder ? 'Return Completed' : 'Order Delivered',
                    statuses: ['DELIVERED'],
                    color: statusColors.DELIVERED,
                    icon: <FaCheckCircle size={9} />,
                    completedIcon: <FaCheckCircle size={9} className="text-white" />,
                    activeIcon: <FaCheckCircle size={9} className="text-white" />
                }
            ];

            return steps;
        };

        const getCurrentStep = () => {
            const steps = getSteps();
            const stepIds = steps.map(step => step.id);

            // Both regular and return orders follow the same status flow
            switch (status) {
                case 'INITIATED':
                    if (isReturnOrder) return 1;
                    return paymentStatus === 'DONE' || paymentMode === 'COD' ?
                        stepIds.indexOf(2) + 1 : // Payment step
                        stepIds.indexOf(1) + 1;  // Order placed step
                case 'CONFIRMED':
                    if (!pidgeOrder) return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                    switch (pidgeOrder.fulfillmentStatus) {
                        case 'CREATED': return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                        case 'OUT_FOR_PICKUP': return stepIds.indexOf(isReturnOrder ? 3 : 4) + 1;
                        case 'REACHED_PICKUP': return stepIds.indexOf(isReturnOrder ? 4 : 5) + 1;
                        case 'PICKED_UP': return stepIds.indexOf(isReturnOrder ? 5 : 6) + 1;
                        case 'OUT_FOR_DELIVERY': return stepIds.indexOf(isReturnOrder ? 6 : 7) + 1;
                        case 'REACHED_DELIVERY': return stepIds.indexOf(isReturnOrder ? 7 : 8) + 1;
                        default: return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                    }
                case 'DELIVERED': return stepIds.indexOf(isReturnOrder ? 8 : 9) + 1;
                case 'REJECTED':
                case 'CANCELLED':
                    return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                default: return 0;
            }
        };

        const steps = getSteps();
        const currentStepIndex = getCurrentStep();
        const currentStepId = steps[currentStepIndex - 1]?.id;

        return (
            <div className="order-tracker-container mb-4 p-3 bg-white rounded-lg shadow-xs">
                <div className="d-flex justify-content-between position-relative">
                    {/* Progress line */}
                    <div className="progress-line position-absolute"
                        style={{
                            height: '2px',
                            top: '12px',
                            left: '40px',
                            right: '40px',
                            backgroundColor: '#F3F4F6',
                            zIndex: 1,
                            borderRadius: '2px',
                            overflow: 'hidden'
                        }}>
                        <div className="progress-active"
                            style={{
                                height: '100%',
                                width: `${((currentStepIndex - 1) / (steps.length - 1)) * 100}%`,
                                backgroundColor: '#D1D5DB',
                                transition: 'width 0.6s ease',
                                zIndex: 2,
                                borderRadius: '2px'
                            }}>
                        </div>
                    </div>

                    {steps.map((step, index) => {
                        const isCompleted = index < currentStepIndex;
                        const isCurrent = index === currentStepIndex - 1;
                        const isActive = isCompleted || isCurrent;

                        const stepColor = isActive ? step.color : '#E5E7EB';
                        const textColor = isActive ? step.color : '#9CA3AF';
                        const fontWeight = isCurrent ? 'font-semibold' : 'font-medium';

                        return (
                            <div key={step.id} className="d-flex flex-column align-items-center position-relative"
                                style={{ zIndex: 3, width: `${100 / steps.length}%` }}>
                                {/* Step indicator */}
                                <div className="position-relative mb-1">
                                    <div className="step-shadow"
                                        style={{
                                            position: 'absolute',
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            top: '-3px',
                                            left: '-3px',
                                            backgroundColor: isActive ? `${step.color}20` : 'transparent',
                                            zIndex: 0
                                        }}>
                                    </div>
                                    <div className={`d-flex align-items-center justify-content-center rounded-circle ${isCurrent ? 'glowing' : ''}`}
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            backgroundColor: stepColor,
                                            border: isCurrent ? `2px solid ${step.color}` : 'none',
                                            transition: 'all 0.3s ease',
                                            position: 'relative',
                                            zIndex: 1
                                        }}>
                                        {isActive ?
                                            (isCurrent ? step.activeIcon : step.completedIcon) :
                                            React.cloneElement(step.icon, { className: "text-gray-400" })
                                        }
                                    </div>
                                </div>

                                {/* Step label */}
                                <div className={`text-center ${fontWeight}`}
                                    style={{
                                        fontSize: '9px',
                                        color: textColor,
                                        transition: 'all 0.3s ease',
                                        lineHeight: '1.2',
                                        maxWidth: '68px',
                                        wordBreak: 'break-word'
                                    }}>
                                    {step.name}
                                </div>

                                {/* Status indicator */}
                                {isCurrent && (
                                    <div className="text-center mt-0.5"
                                        style={{
                                            fontSize: '8px',
                                            color: step.color,
                                            animation: 'fadeInOut 2s infinite'
                                        }}>

                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <style jsx>{`
        @keyframes pulse {
            0% {
                box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
            }
            70% {
                box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);
            }
            100% {
                box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
            }
        }
        
        @keyframes fadeInOut {
            0%, 100% { opacity: 0.8; }
            50% { opacity: 1; }
        }
        
        .glowing {
            animation: pulse 2s infinite;
        }
    `}</style>
            </div>
        );
    };






    const gettoDiscountAmount = orderData?.gettoDiscountAmount;
    const perOrderGettoDiscountAmount = orderData?.orderProducts?.[0]?.gettoDiscountedAmount;
    const amountToShowForGettoDiscount = orderData?.orderType == 1 ? perOrderGettoDiscountAmount : gettoDiscountAmount;



    const isOnlinePaymentPending = orderData?.paymentMode === 'ONLINE' && orderData?.paymentStatus === 'PENDING';
    const commission = (orderData?.orderProducts?.[0]?.Product?.manufacturer?.commission || 0);
    const billingAmount = orderData?.billingAmount || 0;
    const productQuantity = orderData?.orderProducts?.[0]?.quantity || 0;

    const amountPaidByCustomer = billingAmount - gettoDiscountAmount;
    const amountRefundedToCustomer = ((orderData?.orderProducts?.[0]?.originalDiscountedAmount * productQuantity) - orderData?.orderProducts?.[0]?.gettoDiscountedAmount);

    const amountToShowForCustomer = orderData?.orderType == 1 ? amountRefundedToCustomer : amountPaidByCustomer;


    const commissionAmount = Math.round(commission > 0 ? (billingAmount * commission) / 100 : 0);
    const total = billingAmount - commissionAmount;


    return (



        <>
            <style>{customStyles}</style>
            <style>{`
                /* ===== OrderDetails: font-size reductions + responsive layout (no color/design changes) ===== */
                .order_details_wrapper h1 { font-size: 20px !important; }
                .order_details_wrapper h2 { font-size: 18px !important; }
                .order_details_wrapper h3 { font-size: 16px !important; }
                .order_details_wrapper h4 { font-size: 13px !important; line-height: 1.35 !important; }
                .order_details_wrapper h5 { font-size: 12px !important; font-weight: 700 !important; }
                .order_details_wrapper h6 { font-size: 11px !important; }
                .order_details_wrapper p { font-size: 11px !important; margin-bottom: 6px; }
                .order_details_wrapper small,
                .order_details_wrapper .small { font-size: 10px !important; }
                .order_details_wrapper .btn { font-size: 11px !important; padding: 6px 12px !important; }
                .order_details_wrapper .btn-sm { font-size: 10px !important; padding: 4px 8px !important; }
                .order_details_wrapper .custom-rounded-btn { font-size: 11px !important; padding: 5px 12px !important; }
                .order_details_wrapper .badge { font-size: 10px !important; padding: 3px 7px !important; }
                .order_details_wrapper .text-muted { font-size: 11px !important; }
                .order_details_wrapper .card-title { font-size: 13px !important; font-weight: 700 !important; }
                .order_details_wrapper .modal-title { font-size: 15px !important; }
                .order_details_wrapper .modal-title h4 { font-size: 15px !important; }
                .order_details_wrapper label,
                .order_details_wrapper .form-label { font-size: 11px !important; margin-bottom: 4px !important; }
                .order_details_wrapper .form-control,
                .order_details_wrapper .form-select { font-size: 11px !important; padding: 6px 10px !important; min-height: 32px; }
                .order_details_wrapper .form-control::placeholder { font-size: 11px; }
                .order_details_wrapper .table { font-size: 11px !important; }
                .order_details_wrapper .table th,
                .order_details_wrapper .table td { font-size: 11px !important; padding: 8px 10px !important; }
                .order_details_wrapper .list-group-item { font-size: 11px !important; padding: 8px 12px !important; }
                .order_details_wrapper .dropdown-menu { font-size: 11px !important; }
                .order_details_wrapper .dropdown-item { font-size: 11px !important; padding: 6px 12px !important; }
                .order_details_wrapper .nav-link { font-size: 12px !important; }
                .order_details_wrapper input,
                .order_details_wrapper select,
                .order_details_wrapper textarea { font-size: 11px !important; }

                /* Card + table typography */
                .order_details_wrapper .card { border-radius: 10px !important; }
                .order_details_wrapper .card-body { padding: 14px !important; }
                .order_details_wrapper .custom-rounded-table th,
                .order_details_wrapper .custom-rounded-table td { font-size: 11px !important; padding: 8px 10px !important; }
                .order_details_wrapper .user-details-subheading { font-size: 11px !important; font-weight: 600; }
                .order_details_wrapper .user-details-data { font-size: 11px !important; }
                .order_details_wrapper .user-details-address { font-size: 11px !important; line-height: 1.4; }

                /* Order totals — reduce large amounts */
                .order_details_wrapper .order-otp { font-size: 13px !important; font-weight: 700; }

                /* Hide the global topbar on this page — the page header replaces it */
                body:has(.order_details_wrapper) #page-topbar { display: none !important; }
                body:has(.order_details_wrapper) .page-content {
                    padding-top: 0 !important;
                    padding-bottom: 24px !important;
                }

                /* Page header pinned at the top, full-width beyond the sidebar */
                .order_details_wrapper .page-header-sticky {
                    position: fixed !important;
                    top: 0 !important;
                    left: var(--vz-vertical-menu-width, 208px) !important;
                    right: 0 !important;
                    width: auto !important;
                    padding: 18px clamp(20px, 3vw, 48px) !important;
                    margin: 0 !important;
                    background: #f9fafb !important;
                    border-bottom: 1px solid #e5e7eb !important;
                    z-index: 1050 !important;
                }
                .order_details_wrapper { padding-top: 78px !important; }

                /* Back button styling */
                .order_details_wrapper .od-back-btn {
                    display: inline-flex; align-items: center; justify-content: center;
                    width: 30px; height: 30px; border-radius: 4px;
                    font-size: 16px; color: #475569; background: #fff;
                    border: 1px solid #e2e8f0; cursor: pointer;
                    margin-right: 8px; flex-shrink: 0;
                    transition: all 0.15s ease;
                }
                .order_details_wrapper .od-back-btn:hover { color: #008695; border-color: #008695; }

                /* Refresh & invoice buttons trimmed */
                .order_details_wrapper .page-header-sticky button.btn {
                    padding: 6px 12px !important;
                    font-size: 12px !important;
                }
                .order_details_wrapper .page-header-sticky button.btn svg { width: 14px; height: 14px; }

                /* Tables scroll on narrow viewports */
                .order_details_wrapper .table-responsive { overflow-x: auto; -webkit-overflow-scrolling: touch; }
                .order_details_wrapper .custom-rounded-table { min-width: 320px; }

                /* Order tracker */
                .order_details_wrapper .order-tracker-container { padding: 12px !important; }

                /* OTP subheading — hidden on desktop */
                .order_details_wrapper .otp-subheading { display: none; }

                /* Confirm / Reject action buttons — centered content + icon */
                .order_details_wrapper .action-btn {
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 6px;
                    padding: 9px 18px !important;
                    border-radius: 6px !important;
                    font-weight: 600 !important;
                }
                .order_details_wrapper .action-btn-icon {
                    width: 14px; height: 14px;
                    flex-shrink: 0;
                }

                @media (max-width: 767.98px) {
                    /* Make the timeline horizontally scrollable, tighter steps */
                    .order_details_wrapper .order-tracker-container {
                        padding: 10px 0 !important;
                        overflow-x: auto;
                        overflow-y: visible;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: none;
                    }
                    .order_details_wrapper .order-tracker-container::-webkit-scrollbar { display: none; }
                    /* Force horizontal layout with fixed step widths so nothing compresses */
                    .order_details_wrapper .order-tracker-container > .d-flex {
                        justify-content: flex-start !important;
                        padding: 0 12px;
                        min-width: max-content;
                    }
                    .order_details_wrapper .order-tracker-container > .d-flex > div {
                        width: 60px !important;
                        min-width: 60px !important;
                        flex-shrink: 0;
                    }
                    /* Shrink the step circle further */
                    .order_details_wrapper .order-tracker-container .rounded-circle {
                        width: 22px !important;
                        height: 22px !important;
                    }
                    /* Shrink shadow ring proportionally */
                    .order_details_wrapper .order-tracker-container .step-shadow {
                        width: 26px !important;
                        height: 26px !important;
                        top: -2px !important;
                        left: -2px !important;
                    }
                    /* Shrink icons inside step circles */
                    .order_details_wrapper .order-tracker-container .rounded-circle svg {
                        width: 8px !important;
                        height: 8px !important;
                    }
                    /* Progress line aligns with smaller circle center */
                    .order_details_wrapper .order-tracker-container .progress-line {
                        top: 10px !important;
                        left: 42px !important;
                        right: 42px !important;
                    }
                    /* Tiny label text */
                    .order_details_wrapper .order-tracker-container > .d-flex > div > .text-center {
                        font-size: 8px !important;
                        max-width: 58px !important;
                        line-height: 1.2 !important;
                    }
                }

                /* Responsive breakpoints */
                @media (max-width: 991.98px) {
                    .order_details_wrapper .page-header-sticky { padding: 16px 20px !important; }
                    .order_details_wrapper .card-body { padding: 12px !important; }
                }
                /* Mobile-only invoice bar (hidden on desktop) — NOTE: this bar lives outside
                   .order_details_wrapper so selectors must not require it as ancestor */
                .od-invoice-bar { display: none; }

                @media (max-width: 767.98px) {
                    body:has(.order_details_wrapper) .mobile-topbar { display: none !important; }
                    body:has(.order_details_wrapper) .main-content { padding-top: 0 !important; }
                    .order_details_wrapper .page-header-sticky {
                        left: 0 !important;
                        right: 0 !important;
                        padding: 14px 14px !important;
                        gap: 8px !important;
                    }
                    .order_details_wrapper { padding-top: 72px !important; padding-bottom: 220px !important; }

                    /* Header: hide the two invoice buttons + collapse Refresh to icon-only */
                    .order_details_wrapper .od-header-actions .od-invoice-btn { display: none !important; }
                    .order_details_wrapper .od-header-actions .od-refresh-btn {
                        padding: 6px 8px !important;
                        min-width: 34px;
                        justify-content: center;
                    }
                    .order_details_wrapper .od-header-actions .od-refresh-label { display: none !important; }

                    /* Fixed bottom invoice bar (outside wrapper — global selector) */
                    .od-invoice-bar {
                        display: flex !important;
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 0 !important;
                        padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) !important;
                        background: #fff !important;
                        border-top: 1px solid #e2e8f0 !important;
                        box-shadow: 0 -2px 8px rgba(15,23,42,0.05) !important;
                        gap: 10px !important;
                        z-index: 1050 !important;
                    }
                    .od-invoice-btn-m {
                        flex: 1 1 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                        height: 44px;
                        padding: 0 12px;
                        font-size: 12px;
                        font-weight: 600;
                        color: #0f172a;
                        background: #fff;
                        border: 1px solid #e2e8f0;
                        border-radius: 6px;
                        cursor: pointer;
                        transition: all 0.15s ease;
                    }
                    .od-invoice-btn-m:hover:not(:disabled) {
                        border-color: #008695; color: #008695; background: rgba(0,134,149,0.06);
                    }
                    .od-invoice-btn-m-primary {
                        background: #008695;
                        border-color: #008695;
                        color: #fff;
                    }
                    .od-invoice-btn-m-primary:hover:not(:disabled) {
                        background: #006672; border-color: #006672; color: #fff;
                    }
                    .od-invoice-btn-m:disabled { opacity: 0.6; cursor: not-allowed; }

                    /* Fixed OTP bar at the bottom, above the actions bar */
                    .order_details_wrapper .otp-mobile-block {
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 68px !important;
                        margin: 0 !important;
                        padding: 16px 16px 18px !important;
                        background: linear-gradient(180deg, #f0fdfa 0%, #ffffff 100%) !important;
                        border-top: 1px solid #ccfbf1 !important;
                        flex-direction: column !important;
                        justify-content: center !important;
                        align-items: center !important;
                        gap: 12px !important;
                        z-index: 1049;
                        box-shadow: 0 -4px 12px rgba(15,23,42,0.06);
                    }
                    /* Heading + subheading stack */
                    .order_details_wrapper .otp-mobile-block .otp-heading-block {
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 2px;
                    }
                    .order_details_wrapper .otp-mobile-block .otp-label {
                        font-size: 15px !important;
                        font-weight: 700 !important;
                        color: #0f172a !important;
                        margin: 0 !important;
                        letter-spacing: -0.01em;
                    }
                    .order_details_wrapper .otp-mobile-block .otp-subheading {
                        display: block !important;
                        font-size: 11px !important;
                        color: #475569 !important;
                        font-weight: 500;
                        margin: 0;
                    }
                    /* Big centered OTP digits */
                    .order_details_wrapper .otp-mobile-block .otp-container {
                        justify-content: center !important;
                        gap: 8px !important;
                        margin: 0 !important;
                    }
                    .order_details_wrapper .otp-mobile-block .order-otp {
                        font-size: 28px !important;
                        font-weight: 800 !important;
                        color: #0f172a !important;
                        min-width: 44px !important;
                        height: 52px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        border-radius: 8px !important;
                        background: #ffffff !important;
                        border: 1.5px solid #008695 !important;
                        box-shadow: 0 2px 6px rgba(0,134,149,0.15);
                    }
                    /* If no actions bar present, drop OTP to bottom edge */
                    .order_details_wrapper:not(:has(.order-actions-bar .btn)) .otp-mobile-block {
                        bottom: 0 !important;
                        padding-bottom: calc(18px + env(safe-area-inset-bottom, 0px)) !important;
                    }

                    /* Fixed action bar (Confirm / Reject) at the bottom */
                    .order_details_wrapper .order-actions-row {
                        display: block !important;
                    }
                    .order_details_wrapper .order-actions-row > div:first-child { display: none; }
                    .order_details_wrapper .order-actions-bar:has(.btn) {
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 0 !important;
                        margin: 0 !important;
                        padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) !important;
                        background: #fff !important;
                        border-top: 1px solid #e2e8f0 !important;
                        gap: 10px !important;
                        z-index: 1050;
                        justify-content: stretch !important;
                        box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                    }
                    .order_details_wrapper .order-actions-bar:has(.btn) > .btn {
                        flex: 1 1 0 !important;
                        height: auto !important;
                        padding: 12px 16px !important;
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        border-radius: 6px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        gap: 6px;
                    }
                    .order_details_wrapper .order-actions-bar .action-btn-icon {
                        width: 16px; height: 16px;
                    }
                    .order_details_wrapper .page-header-sticky h3 { font-size: 15px !important; }
                    /* Compact header actions on mobile */
                    .order_details_wrapper .page-header-sticky button.btn {
                        padding: 5px 10px !important;
                        font-size: 11px !important;
                    }
                    .order_details_wrapper .card-body { padding: 10px !important; }
                    /* Stack Bootstrap grid cols */
                    .order_details_wrapper .row > [class*="col-md-"],
                    .order_details_wrapper .row > [class*="col-lg-"] {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                    /* Any right-aligned column block should wrap on mobile */
                    .order_details_wrapper .d-flex.justify-content-between.align-items-start,
                    .order_details_wrapper .d-flex.justify-content-between {
                        flex-wrap: wrap !important;
                        gap: 10px !important;
                    }
                    .order_details_wrapper .d-flex.flex-column.align-items-end {
                        align-items: flex-start !important;
                        width: 100%;
                    }
                    /* Prevent tables from breaking layout */
                    .order_details_wrapper table.table {
                        display: block;
                        overflow-x: auto;
                        white-space: nowrap;
                    }
                    .order_details_wrapper .custom-rounded-table td,
                    .order_details_wrapper .custom-rounded-table th {
                        white-space: normal;
                        padding: 6px 8px !important;
                    }
                    /* Product images shrink */
                    .order_details_wrapper .order-product-image { max-width: 80px !important; height: auto !important; }
                    /* OTP boxes tighter */
                    .order_details_wrapper .order-otp {
                        width: 26px !important; height: 32px !important;
                        font-size: 12px !important;
                    }
                }
                @media (max-width: 480px) {
                    .order_details_wrapper .page-header-sticky h3 { font-size: 14px !important; }
                    .order_details_wrapper h4 { font-size: 13px !important; }
                    .order_details_wrapper .card-body { padding: 10px !important; }
                }
            `}</style>
            <div className='order_details_wrapper'>
                {(
                    <>
                        <div className="page-header-sticky d-flex align-items-center justify-content-between flex-wrap gap-3">
                            <div className="d-flex align-items-center">
                                <button
                                    type="button"
                                    className="od-back-btn back-btn"
                                    onClick={() => navigate(-1)}
                                    aria-label="Back"
                                >
                                    <IoMdArrowBack />
                                </button>
                                <h3 className="mb-0 fw-bold">Order details</h3>
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-wrap od-header-actions">
                                {orderData?.status === "DELIVERED" &&
                                    orderData?.orderType == null &&
                                    orderData?.returnId == null && (
                                        <>
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleDownloadVendorInvoice}
                                                className="custom-rounded-btn od-invoice-btn"
                                            >
                                                {downloadVendorInvoice ? (
                                                    <>
                                                        <Spinner as="span" animation="border" size="sm" />
                                                        <span className="ms-2">downloading ...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaDownload /> Vendor invoice
                                                    </>
                                                )}
                                            </Button>

                                            <Button
                                                variant="outline-primary"
                                                onClick={handleDownloadCustomerInvoice}
                                                className="custom-rounded-btn od-invoice-btn"
                                            >
                                                {downloadCustomerInvoice ? (
                                                    <>
                                                        <Spinner as="span" animation="border" size="sm" />
                                                        <span className="ms-2">downloading ...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaDownload /> Customer invoice
                                                    </>
                                                )}
                                            </Button>
                                        </>
                                    )
                                }

                                <button
                                    onClick={handleRefresh}
                                    className="btn border border-secondary bg-white rounded-3 d-inline-flex align-items-center gap-2 od-refresh-btn"
                                    style={{
                                        padding: '8px 14px',
                                        fontSize: '11px',
                                        color: '#374151',
                                    }}
                                    disabled={refreshing || loading}
                                    title="Refresh order details"
                                    aria-label="Refresh"
                                >
                                    <FiRefreshCw
                                        size={16}
                                        style={{
                                            transition: "transform 0.3s ease-in-out",
                                            transform: refreshing ? "rotate(360deg)" : "rotate(0deg)",
                                            animation: refreshing ? "spin 1s linear infinite" : "none"
                                        }}
                                    />
                                    <span className="od-refresh-label">
                                        {refreshing ? "Refreshing..." : "Refresh"}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className="row">



                        {



                            loading ?

                                <div className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
                                    <Loader />
                                </div>

                                :

                                error ? (
                                    <ErrorState onRetry={handleRefresh} />
                                ) :

                                    (<div className="mt-0">
                                        <div className="card custom-rounded-card mb-4">

                                            <div className="card-body">
                                                <div className='d-flex justify-content-between align-items-start mb-4'>
                                                    <div>
                                                        <div className="d-flex align-items-center gap-3" style={{ minHeight: "38px" }}>
                                                            <h4 className="mb-0" style={{
                                                                lineHeight: "26px",
                                                                height: "26px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                fontWeight: 400 // thin for label
                                                            }}>
                                                                Order Id :  <span style={{ fontWeight: 700, marginLeft: 4 }}>{orderData?.orderId}</span>
                                                            </h4>

                                                            {orderData?.isScheduled && (
                                                                <span
                                                                    style={{
                                                                        height: "26px",
                                                                        padding: "0 10px",
                                                                        fontSize: "12px",
                                                                        fontWeight: "600",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        letterSpacing: "0.5px",
                                                                        background: "#fff3cd",
                                                                        border: "1px solid #ffc107",
                                                                        borderRadius: "4px",
                                                                        color: "#856404"
                                                                    }}
                                                                >
                                                                    SCHEDULED
                                                                </span>
                                                            )}

                                                            <span
                                                                className={`custom-rounded-btn ${orderData?.status === 'INITIATED'
                                                                    ? "yellow"
                                                                    : orderData?.orderType == 2
                                                                        ? "red"
                                                                        : orderData?.orderType == 1 || orderData?.status === 'REJECTED'
                                                                            ? "red"
                                                                            : "bg-primary"
                                                                    }`}
                                                                style={{
                                                                    height: "26px",
                                                                    padding: "0 10px",
                                                                    fontSize: "12px",
                                                                    fontWeight: "400",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    letterSpacing: "0.5px"
                                                                }}
                                                            >
                                                                {orderData?.orderType === 2
                                                                    ? "EXCHANGE"
                                                                    : orderData?.orderType === 1
                                                                        ? "RETURN"
                                                                        : ""}{" "}
                                                                {orderData?.status}

                                                                {orderData?.statusForExchangeOrder === 1 && orderData?.orderType === 2 && orderData?.orderStatus === "DELIVERED"
                                                                    ? " TO VENDOR"

                                                                    : ""}{" "}


                                                            </span>
                                                        </div>

                                                        <div
                                                            style={{
                                                                border: "1px solid #dee2e6",
                                                                borderRadius: "6px",
                                                                padding: "4px 10px",
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                fontWeight: 600,
                                                                fontSize: "11px",
                                                                background: "#f8f9fa",
                                                                marginTop: "8px",
                                                                marginRight: "12px"
                                                            }}
                                                        >
                                                            <FaRegCalendarAlt style={{ marginRight: 6, color: "#007ea9" }} />
                                                            <span className="text-muted" style={{ fontWeight: 600 }}>
                                                                {moment(orderData?.createdAt).format('DD/MM/YYYY, hh:mm a')}
                                                            </span>
                                                        </div>


                                                        {orderData?.parentOrderId && (
                                                            <span
                                                                onClick={() => navigate('/orderdetails/' + orderData.parentOrderId)}
                                                                style={{
                                                                    fontSize: "12px",
                                                                    fontWeight: "700",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    color: "#0b6fa5ff", // Bootstrap blue
                                                                    textDecoration: "underline"
                                                                }}
                                                            >
                                                                Check parent order → {orderData.parentOrderId}
                                                            </span>
                                                        )}

                                                        {/* Show Return Ids */}
                                                        {orderData?.returnIdForVedor && (
                                                            <>
                                                                <span

                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "700",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        color: "red",
                                                                        marginLeft: "5px",
                                                                    }}
                                                                >
                                                                    Check returned order →

                                                                </span>
                                                                {(
                                                                    typeof orderData.returnIdForVedor === 'string'
                                                                        ? orderData.returnIdForVedor.split(',').map(id => id.trim())
                                                                        : orderData.returnIdForVedor
                                                                ).map((id, index) => (
                                                                    <span
                                                                        key={`return-${id}-${index}`}
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            fontWeight: "700",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            marginLeft: "10px",
                                                                            color: "red",
                                                                        }}
                                                                    >
                                                                        {' '}
                                                                        <span
                                                                            onClick={() => navigate('/orderdetails/' + id)}
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                color: "red",
                                                                                textDecoration: "underline",
                                                                            }}
                                                                        >
                                                                            {id}
                                                                        </span>
                                                                    </span>
                                                                ))}
                                                            </>
                                                        )}


                                                        {/* Show Exchange Ids */}
                                                        {orderData?.exchangeIdForVedor && (
                                                            <>

                                                                <span

                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "700",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        marginLeft: "15px",

                                                                        color: "#0b6a93ff",
                                                                    }}
                                                                >
                                                                    Check exchanged order →

                                                                </span>
                                                                {(
                                                                    typeof orderData.exchangeIdForVedor === 'string'
                                                                        ? orderData.exchangeIdForVedor.split(',').map(id => id.trim())
                                                                        : orderData.exchangeIdForVedor
                                                                ).map((id, index) => (
                                                                    <span
                                                                        key={`exchange-${id}-${index}`}
                                                                        onClick={() => navigate('/orderdetails/' + id)}
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            fontWeight: "700",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            cursor: "pointer",
                                                                            color: "#0b6a93ff",
                                                                            textDecoration: "underline",
                                                                            marginLeft: "10px"
                                                                        }}
                                                                    >
                                                                        {id}
                                                                    </span>
                                                                ))}
                                                            </>
                                                        )}

                                                    </div>



                                                    <div className='d-flex flex-column align-items-end order-otp-wrap'>
                                                        {(orderData?.orderType === 2 || orderData?.orderType === null) && orderData?.status === "CONFIRMED" && orderData?.deliveryStatus === "PENDING" && orderData?.pidgeOrder?.pickupOtp && (
                                                            <div className='d-flex align-items-center mb-2 otp-mobile-block'>
                                                                <div className='otp-heading-block'>
                                                                    <h5 className="mb-0 otp-label">Pickup OTP</h5>
                                                                    <div className="otp-subheading">Share this OTP with the driver at pickup</div>
                                                                </div>
                                                                <div className='otp-container d-flex'>
                                                                    {renderOtpDigits(orderData.pidgeOrder.pickupOtp)}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {orderData?.orderType === 1 && orderData?.status === "CONFIRMED" && orderData?.deliveryStatus === "DISPATCHED" && orderData?.pidgeOrder?.dropOtp && (
                                                            <div className='d-flex align-items-center mb-2 otp-mobile-block'>
                                                                <div className='otp-heading-block'>
                                                                    <h5 className="mb-0 otp-label">Drop OTP</h5>
                                                                    <div className="otp-subheading">Share this OTP with the driver at delivery</div>
                                                                </div>
                                                                <div className='otp-container d-flex'>
                                                                    {renderOtpDigits(orderData.pidgeOrder.dropOtp)}
                                                                </div>
                                                            </div>
                                                        )}





                                                    </div>
                                                </div>

                                                <div className='d-flex justify-content-between align-items-center order-actions-row'>
                                                    <div></div>
                                                    <div className='d-flex gap-3 order-actions-bar'>

                                                        {(orderData?.status === 'INITIATED' && orderData?.orderType === null) && (
                                                            <>
                                                                <Button
                                                                    onClick={() => handleCancelOrder()}
                                                                    className="custom-rounded-btn red action-btn action-btn-reject"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? (
                                                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                                    ) : (
                                                                        <>
                                                                            <FaRegCircleXmark className="action-btn-icon" />
                                                                            <span>Reject</span>
                                                                        </>
                                                                    )}
                                                                </Button>
                                                                <Button
                                                                    onClick={() => handleApproveOrder()}
                                                                    className="custom-rounded-btn blue action-btn action-btn-confirm"
                                                                    disabled={isOnlinePaymentPending || loading}
                                                                >
                                                                    {isOnlinePaymentPending ? (
                                                                        <span>Waiting for Payment</span>
                                                                    ) : (
                                                                        <>
                                                                            <FaRegCircleCheck className="action-btn-icon" />
                                                                            <span>Confirm</span>
                                                                        </>
                                                                    )}
                                                                </Button>
                                                            </>
                                                        )}

                                                        {(orderData?.status === 'INITIATED' && orderData?.orderType !== null) && (
                                                            <>
                                                                <Button
                                                                    onClick={handleEvidenceModalShow}
                                                                    className="custom-rounded-btn blue"
                                                                    disabled={isOnlinePaymentPending || loading}
                                                                >
                                                                    {isOnlinePaymentPending ? (
                                                                        <>
                                                                            <span className="ms-2">Waiting for Payment</span>
                                                                        </>
                                                                    ) : (
                                                                        `Check ${orderData?.orderType === 1 ? 'Return' : orderData?.orderType === 2 ? 'Exchange' : ''} Evidence`
                                                                    )}
                                                                </Button>
                                                            </>
                                                        )}


                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {orderData?.isScheduled && orderData?.scheduledOrderJobs?.length > 0 && (
                                            <div className="card custom-rounded-card mb-3 border-warning">
                                                <div className="card-body py-3">
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">

                                                        <div className="d-flex align-items-center gap-3">
                                                            <div
                                                                style={{
                                                                    width: "42px",
                                                                    height: "42px",
                                                                    borderRadius: "10px",
                                                                    background: "#fff3cd",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                <FaRegCalendarAlt size={20} color="#856404" />
                                                            </div>

                                                            <div>
                                                                <h6
                                                                    className="mb-1"
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        color: "#856404"
                                                                    }}
                                                                >
                                                                    Scheduled Order
                                                                </h6>

                                                                <div
                                                                    className="d-flex align-items-center gap-3 flex-wrap"
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: 500
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {moment(
                                                                            orderData?.scheduledOrderJobs?.[0]?.scheduledDate
                                                                        ).format("DD MMM YYYY")}
                                                                    </span>

                                                                    <span
                                                                        style={{
                                                                            width: "5px",
                                                                            height: "5px",
                                                                            borderRadius: "50%",
                                                                            background: "#adb5bd",
                                                                            display: "inline-block"
                                                                        }}
                                                                    />

                                                                    <span>
                                                                        {
                                                                            orderData?.scheduledOrderJobs?.[0]?.slot
                                                                                ?.label
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="mt-3 mt-md-0">
                                                            <span
                                                                className={`badge px-3 py-2 ${orderData?.scheduledOrderJobs?.[0]?.status ===
                                                                        "PENDING"
                                                                        ? "bg-warning text-dark"
                                                                        : orderData?.scheduledOrderJobs?.[0]
                                                                            ?.status === "COMPLETED"
                                                                            ? "bg-success"
                                                                            : orderData?.scheduledOrderJobs?.[0]
                                                                                ?.status === "CANCELLED"
                                                                                ? "bg-danger"
                                                                                : "bg-secondary"
                                                                    }`}
                                                                style={{
                                                                    fontSize: "11px",
                                                                    borderRadius: "6px",
                                                                    letterSpacing: "0.5px"
                                                                }}
                                                            >
                                                                {orderData?.scheduledOrderJobs?.[0]?.status}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <OrderStatusTracker
                                            status={orderData?.status}
                                            type={orderData?.orderType}
                                            paymentMode={orderData?.paymentMode}
                                            paymentStatus={orderData?.paymentStatus}
                                            pidgeOrder={orderData?.pidgeOrder}
                                        />

                                        <div className="row">
                                            {/* Order Details on Left */}
                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <div className='d-flex justify-content-between align-items-center mb-4'>
                                                            <h4 className="card-title mb-0">Product details</h4>

                                                        </div>

                                                        {orderData?.orderProducts?.length === 0 ? (
                                                            <div className='text-center py-4'>
                                                                <p>No products found</p>
                                                            </div>
                                                        ) : (
                                                            orderData?.orderProducts?.map((item, i) => {
                                                                // Find returns for this specific product using orderproductid
                                                                const productReturns = orderData.orderProducts.flatMap(product =>
                                                                    product.returns || []
                                                                ).filter(returnItem => returnItem.orderproductid === item.id);

                                                                const hasReturnOrExchange = productReturns.length > 0;
                                                                const returnType = hasReturnOrExchange ? productReturns[0].type : null;
                                                                const returnStatus = hasReturnOrExchange ? productReturns[0].status : null;

                                                                return (
                                                                    <div key={i} className='border-bottom pb-3 mb-3'>
                                                                        <div className='d-flex'>
                                                                            <div className='me-3 position-relative'>

                                                                                <div style={{ height: "80px", width: "80px" }}>
                                                                                    {item?.Product?.images?.[0]?.image_url !== '' ?
                                                                                        <img
                                                                                            src={item?.Product?.images?.[0]?.image_url}

                                                                                            className="img-fluid custom-rounded-img"
                                                                                            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = '';
                                                                                            }}
                                                                                        /> : <BsImageAlt size={80} color="#ccc" />}

                                                                                </div>




                                                                                {/* RETURN/EXCHANGE STAMP - ADDED THIS CODE */}
                                                                                {hasReturnOrExchange && (
                                                                                    <div
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '5px',
                                                                                            right: '5px',
                                                                                            backgroundColor: returnType === 1
                                                                                                ? 'rgba(220, 53, 69, 0.9)'
                                                                                                : 'rgba(13, 110, 253, 0.9)',
                                                                                            color: 'white',
                                                                                            padding: '3px 6px',
                                                                                            borderRadius: '3px',
                                                                                            fontSize: '9px',
                                                                                            fontWeight: 'bold',
                                                                                            transform: 'rotate(15deg)',
                                                                                            boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                                                                                            zIndex: 10,
                                                                                            textTransform: 'uppercase',
                                                                                            letterSpacing: '0.5px'
                                                                                        }}
                                                                                    >
                                                                                        {returnType === 1 ? 'Returned' : 'Exchanged'}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className='flex-grow-1'>
                                                                                <h6 className="mb-1">{item?.Product?.productName}</h6>

                                                                                <div className="d-flex flex-wrap gap-2">
                                                                                    {item?.Product?.size && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Size:</small>
                                                                                            <small>{item?.Product?.size}</small>
                                                                                        </div>
                                                                                    )}

                                                                                    {item?.quantity && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Qty:</small>
                                                                                            <small>{item?.quantity}</small>
                                                                                        </div>
                                                                                    )}

                                                                                    {item?.VariationSize && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Size:</small>
                                                                                            <small>{item?.VariationSize?.size}</small>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                {/* Show return/exchange details if applicable */}
                                                                                {hasReturnOrExchange && (
                                                                                    <div className="mt-2 p-2 bg-light rounded">

                                                                                        {productReturns[0]?.reason && (
                                                                                            <small className="text-muted d-block">
                                                                                                Reason: {productReturns[0].reason}
                                                                                            </small>
                                                                                        )}
                                                                                        {productReturns[0]?.comments && (
                                                                                            <small className="text-muted d-block">
                                                                                                Comments: {productReturns[0].comments}
                                                                                            </small>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className='text-end'>
                                                                                <div className="d-flex flex-column" style={{ width: '120px' }}>
                                                                                    <h6 className="mb-0">Rs {item.originalDiscountedAmount * item.quantity}</h6>
                                                                                    <small className="text-muted text-decoration-line-through">Rs {item.originalBillingAmount * item.quantity}</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Vendor Details on Right */}
                                            {(userType === 'ADMIN' || userType === 'customerSupport') &&
                                                <div className='col-md-6 mb-4'>
                                                    <div className='card custom-rounded-card h-100'>
                                                        <div className='card-body'>
                                                            <h4 className="card-title mb-4">Vendor details</h4>
                                                            <Table bordered className="custom-rounded-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Name:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.storeName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Mobile Number:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.phoneNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Email Address:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.email}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Address: </td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.orderProducts?.[0]?.Product?.manufacturer?.address}, {orderData?.orderProducts?.[0]?.Product?.manufacturer?.landmark}<br />
                                                                            {orderData?.orderProducts?.[0]?.Product?.manufacturer?.city}, {orderData?.orderProducts?.[0]?.Product?.manufacturer?.state}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>}

                                            {/* Amount paid by customer on Left */}
                                            {checkUserPermissions('admin') && orderData?.orderType !== 2 && <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">{orderData?.orderType === 1 ? 'Amount refunded to customer' : 'Amount paid by customer'}</h4>

                                                        <div className='mb-3'>
                                                            <div className='d-flex justify-content-between mb-2'>
                                                                <span>Amount</span>
                                                                <span>Rs  {amountToShowForCustomer + amountToShowForGettoDiscount}</span>

                                                            </div>

                                                            <div className='d-flex justify-content-between mb-2'>
                                                                <span>Discount amount</span>
                                                                <span>Rs  {amountToShowForGettoDiscount}</span>

                                                            </div>






                                                        </div>

                                                        <div className='d-flex justify-content-between border-top pt-3'>
                                                            <h5 className=''>{orderData?.orderType === 1 ? 'Refunded Amount' : 'Total Amount'}</h5>
                                                            <h5 className='fw-semibold'>Rs {amountToShowForCustomer.toFixed(2)}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}

                                            {/* Billing Details on right */}
                                            {(orderData?.orderType === null && (orderData?.status === "CONFIRMED" || orderData?.status === "INITIATED" || orderData?.status === "DELIVERED")) && <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">{userType == 'Vendor' ? 'Billing Details' : 'Amount paid to vendor'}</h4>

                                                        <div className='mb-3'>
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Amount</span>
                                                                <span>Rs {billingAmount.toFixed(2)}</span>
                                                            </div>

                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Commission ({commission}%)</span>
                                                                <span>Rs {commissionAmount.toFixed(2)}</span>
                                                            </div>


                                                        </div>

                                                        <div className='d-flex justify-content-between border-top pt-3'>
                                                            <h5 className=''>{orderData?.orderType === 1 ? 'Refundable Amount' : 'Total Amount'}</h5>
                                                            <h5 className='fw-semibold'>Rs {total.toFixed(2)}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}


                                            {/* Delivery Partner Charge and Offer Charges on Right */}

                                            {checkUserPermissions('admin') && orderData?.orderType !== 2
                                                ?
                                                <div className='col-md-12 mb-4'>
                                                    <div className='row h-100'>
                                                        <div className='col-md-6 mb-3 mb-md-0'>
                                                            <div className='card custom-rounded-card h-100'>
                                                                <div className='card-body'>
                                                                    <h4 className="card-title mb-4">Pidge delivery charge</h4>
                                                                    <div className='d-flex justify-content-between mb-2'>
                                                                        <span>Delivery Fee</span>
                                                                        <span>Rs {orderData?.voltaOrder === null ? orderData?.deliveryAmount : orderData?.voltaOrder?.minorAmount}</span>
                                                                    </div>

                                                                    <div className='d-flex justify-content-between border-top pt-2'>
                                                                        <h6>Total</h6>
                                                                        <h6>Rs {orderData?.voltaOrder === null ? orderData?.deliveryAmount : orderData?.voltaOrder?.minorAmount}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className='card custom-rounded-card h-100'>
                                                                <div className='card-body'>
                                                                    <h4 className="card-title mb-4">Getto discount amount</h4>
                                                                    <div className='d-flex justify-content-between mb-2'>
                                                                        <span>Discount</span>
                                                                        <span>Rs.{amountToShowForGettoDiscount}</span>
                                                                    </div>

                                                                    <div className='d-flex justify-content-between border-top pt-2'>
                                                                        <h6>Total</h6>
                                                                        <h6>Rs.{amountToShowForGettoDiscount}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div></div>
                                            }


                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">User details</h4>
                                                        {checkUserPermissions('admin') ? <NotMaskedUserData /> : <MaskedUserData />}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">Order payment details</h4>
                                                        <Table bordered className="custom-rounded-table">
                                                            <tbody>
                                                                {orderData?.paymentMode && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Mode:</td>
                                                                        <td className='user-details-data'>{orderData?.paymentMode}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.paymentStatus && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Status:</td>
                                                                        <td className='user-details-data'>{orderData?.paymentStatus}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.razorpayOrderId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Razorpay Order ID:</td>
                                                                        <td className='user-details-data'>{orderData?.razorpayOrderId}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.shipRocketOrderId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Shipment Order ID:</td>
                                                                        <td className='user-details-data'>{orderData?.shipRocketOrderId}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.shiprocketShipmentId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Shipment ID:</td>
                                                                        <td className='user-details-data'>{orderData?.shiprocketShipmentId}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>

                                            {checkUserPermissions('admin') && (
                                                <div className='col-12 mb-4'>
                                                    <div className='card custom-rounded-card'>
                                                        <div className='card-body'>
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h4 className="card-title mb-0">Delivery details</h4>
                                                                <Button variant="link" onClick={() => copyToClipBoard()} className="p-0">
                                                                    <FaRegCopy size={20} />
                                                                </Button>
                                                            </div>

                                                            <Table bordered className="custom-rounded-table delivery-details-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Order ID:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.orderId ? orderData.orderId : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Name:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.storeName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Number:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.phoneNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Pick Up Location:</td>
                                                                        <td className='user-details-data'>
                                                                            https://www.google.com/maps?q={orderData?.orderProducts?.[0]?.Product?.manufacturer?.latitude},{orderData?.orderProducts?.[0]?.Product?.manufacturer?.longitude}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Name:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.customerName ? orderData.Address.customerName : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Number:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile}` : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Mode:</td>
                                                                        <td className='user-details-data'> {orderData?.paymentMode} </td>
                                                                    </tr>
                                                                    <tr className={orderData?.paymentMode === 'ONLINE' ? 'mask-details' : ''}>
                                                                        <td className='user-details-subheading'>Cash to be collected:</td>
                                                                        <td className='user-details-data'>Rs.{orderData?.billingAmount}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Address:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.line1}, {orderData?.Address?.line2}, {orderData?.Address?.locality}<br />
                                                                            {orderData?.Address?.city}, {orderData?.Address?.state}, Pincode: {orderData?.Address?.postalCode}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Drop Location:</td>
                                                                        <td className='user-details-data'>
                                                                            https://www.google.com/maps?q={orderData?.Address?.latitude},{orderData?.Address?.longitude}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>)}


                    </div>
                    </>
                )}
            </div>

            {/* Return & Exchange Modal */}
            <Modal show={showOrder} onHide={handleCloseOrder} centered className="custom-rounded-modal">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title>
                        <h5 className="mb-0">
                            {orderItem?.type == "1" ? "Return" : "Exchange"} Order
                        </h5>
                        <small className="text-muted">Order Id: {orderData?.orderId}</small>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="mb-4">
                                <h6 className="mb-3">Product Details</h6>

                                <div className="d-flex border rounded p-3 custom-rounded">
                                    <div className="me-3">
                                        <img
                                            src={orderItem?.orderItemProducts?.Product?.ProductImages?.[0]?.image_url}
                                            alt="product"
                                            className="img-fluid custom-rounded-img"
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', background: 'red' }}
                                        />
                                    </div>

                                    <div className="flex-grow-1">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-1">{orderItem?.orderItemProducts?.Product?.productName}</h6>

                                                <div className="d-flex flex-wrap gap-2">
                                                    {orderItem?.orderItemProducts?.Product?.size && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Size:</small>
                                                            <small>{orderItem?.orderItemProducts?.Product?.size}</small>
                                                        </div>
                                                    )}

                                                    {orderItem?.orderItemProducts?.quantity && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Qty:</small>
                                                            <small>{orderItem?.orderItemProducts?.quantity}</small>
                                                        </div>
                                                    )}

                                                    {orderItem?.orderItemProducts?.VariationSize && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Size:</small>
                                                            <small>{orderItem?.orderItemProducts?.VariationSize?.size}</small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="text-end">
                                                <h6 className="mb-0">Rs {orderItem?.orderItemProducts?.Product?.discountedPrice}</h6>
                                                <small className="text-muted text-decoration-line-through">Rs {orderItem?.orderItemProducts?.Product?.price}</small>

                                                <div
                                                    className="mt-2 ms-auto color-code"
                                                ></div>
                                            </div>
                                        </div>

                                        {(orderItem?.orderItemProducts?.returns?.[0]?.comments || orderItem?.orderItemProducts?.returns?.[0]?.reason) && (
                                            <div className="mt-3 pt-2 border-top">
                                                {orderItem?.orderItemProducts?.returns?.[0]?.comments && (
                                                    <div className="mb-1">
                                                        <small className="text-muted">Comment:</small>
                                                        <small className="ms-2">{orderItem?.orderItemProducts?.returns?.[0]?.comments}</small>
                                                    </div>
                                                )}

                                                {orderItem?.orderItemProducts?.returns?.[0]?.reason && (
                                                    <div>
                                                        <small className="text-muted">Reason:</small>
                                                        <small className="ms-2">{orderItem?.orderItemProducts?.returns?.[0]?.reason}</small>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center gap-3">
                                <Button
                                    variant="outline-success"
                                    onClick={() => handleOrderReturnExchange(orderItem?.id, 2)}
                                    className="d-flex align-items-center custom-rounded-btn blue"
                                >
                                    <img src={tickIcon} alt="approve" className="me-2" /> Approve
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    onClick={() => handleOrderReturnExchange(orderItem?.id, 3)}
                                    className="d-flex align-items-center custom-rounded-btn red"
                                >
                                    <img src={closeIcon} alt="reject" className="me-2" /> Reject
                                </Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {/* {(stickyVideo && (orderData.orderType == 1 || orderData.orderType == 2)) && (
                <div
                    className="sticky-video-container"
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        zIndex: 1060,
                        width: '180px',
                        background: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden', // ensures rounded corners apply to video too
                    }}
                >
                    <div className="sticky-video-player">
                        <div
                            className="video-header"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '6px 10px',
                                background: '#f8f9fa',
                                borderBottom: '1px solid #dee2e6',
                            }}
                        >
                            <span style={{ fontSize: '11px', fontWeight: 700 }}>
                                {stickyVideo.type} Evidence Video
                            </span>
                            <button
                                onClick={() => setStickyVideo(null)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                }}
                            >
                                <IoMdClose size={14} />
                            </button>
                        </div>

                        <video
                            key={stickyVideo.url}
                            autoPlay
                            muted
                            loop
                            controls
                            playsInline
                            style={{
                                width: '100%',
                                height: '160px', // reduced from 320px
                                objectFit: 'cover',
                                display: 'block',
                                background: '#000',
                                borderRadius: '0 0 12px 12px', // rounded bottom corners
                            }}
                        >
                            <source src={stickyVideo.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )} */}

            {/* Evidence Check Modal */}
            <Modal
                show={showEvidenceModal}
                onHide={handleEvidenceModalClose}
                centered
                size="lg"
            >
                {/* HEADER */}
                <Modal.Header
                    closeButton
                    style={{
                        borderBottom: '1px solid #dee2e6',
                        padding: '1rem 1.5rem 0.5rem 1.5rem'
                    }}
                >
                    <Modal.Title>
                        <h4 className="py-1 fw-bold">
                            Check {orderData?.orderType == '1' ? 'Return' : 'Exchange'} Evidence
                        </h4>
                    </Modal.Title>
                </Modal.Header>

                {/* BODY */}
                <Modal.Body
                    style={{
                        padding: 0,
                        maxHeight: '70vh',
                        overflowY: 'auto'
                    }}
                >
                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) :

                        (
                            <div className="row g-0" style={{ minHeight: '400px' }}>

                                {/* LEFT SIDE - Rejection Reasons */}
                                <div
                                    className="col-md-6 p-4"
                                    style={{
                                        borderRight: '1px solid #dee2e6',
                                        background: '#fff'
                                    }}
                                >
                                    <h6 style={{ marginBottom: '1rem', fontWeight: '600' }}>Rejection Reason</h6>

                                    {/* Dropdown for rejection reasons */}
                                    <Form.Group>
                                        <Form.Select
                                            value={rejectionReason}
                                            onChange={(e) => setRejectionReason(e.target.value)}
                                            style={{
                                                fontSize: '12px',
                                                borderRadius: '6px',
                                                border: '1px solid #6c757d'
                                            }}
                                        >
                                            <option value="">Choose a rejection reason...</option>
                                            {rejectionReasons.map((reason, index) => (
                                                <option key={index} value={reason}>
                                                    {reason}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    {/* Always show Specific Reason input */}
                                    {/* Add this below the custom reason textarea */}
                                    <Form.Group style={{ marginTop: '1rem' }}>
                                        <Form.Label style={{ fontSize: '11px', fontWeight: '500' }}>
                                            Any other reason:
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Provide specific reason for rejection (minimum 10 characters)..."
                                            value={customReason}
                                            onChange={(e) => setCustomReason(e.target.value)}
                                            style={{
                                                fontSize: '12px',
                                                borderRadius: '6px',
                                                border: '1px solid #6c757d',
                                                minHeight: '100px'
                                            }}
                                        />
                                        <div
                                            style={{
                                                fontSize: '12px',
                                                textAlign: 'right',
                                                marginTop: '4px',
                                                color: customReason && customReason.trim().length >= 10 ? '#28a745' : '#6c757d'
                                            }}
                                        >
                                            {customReason?.length || 0}/10 characters
                                            {customReason && customReason.trim().length >= 10 && ' ✓'}
                                        </div>
                                    </Form.Group>
                                </div>


                                {/* RIGHT SIDE - Video */}
                                <div className="col-md-6 p-4" style={{ background: '#f8f9fa' }}>
                                    {stickyVideo ? (
                                        <div
                                            style={{
                                                border: '1px solid #dee2e6',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                backgroundColor: '#000',
                                                height: '350px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'

                                            }}
                                        >
                                            <video
                                                key={stickyVideo.url}
                                                controls
                                                autoPlay
                                                muted
                                                playsInline
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain'
                                                }}
                                            >
                                                <source src={stickyVideo.url} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </video>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                border: '1px solid #dee2e6',
                                                borderRadius: '8px',
                                                background: '#fff',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <div>
                                                <FiImage size={36} className="text-muted mb-2" />
                                                <p className="text-muted mb-0 small">No evidence video available</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )

                    }
                </Modal.Body>

                \
                {/* STICKY FOOTER */}
                <Modal.Footer
                    style={{
                        borderTop: '1px solid #dee2e6',
                        padding: '1rem 1.5rem',
                        background: '#f8f9fa',
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 10
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            width: '100%',
                            gap: '12px'
                        }}
                    >
                        <Button
                            variant="outline-secondary"
                            onClick={handleEvidenceModalClose}
                            style={{
                                borderRadius: '6px',
                                padding: '8px 24px',
                                minWidth: '100px'
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="danger"
                            onClick={handleRejectOrder}
                            disabled={loading || !(
                                rejectionReason ||
                                (customReason && customReason.trim().length >= 10)
                            )}
                            style={{
                                borderRadius: '6px',
                                padding: '8px 24px',
                                minWidth: '100px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            {loading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" />
                                    Processing...
                                </>
                            ) : (
                                <>Reject</>
                            )}
                        </Button>

                        <Button
                            variant="success"
                            onClick={handleApproveOrder}
                            disabled={loading || (
                                rejectionReason ||
                                (customReason.trim().length > 0)
                            )}
                            style={{
                                borderRadius: '6px',
                                padding: '8px 24px',
                                minWidth: '100px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            {loading ? (
                                <>
                                    <Spinner as="span" animation="border" size="sm" />
                                    Processing...
                                </>
                            ) : (
                                <>Confirm</>
                            )}
                        </Button>
                    </div>
                </Modal.Footer>

            </Modal>

            {/* CSS Styles */}
            <style>
                {`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none; /* Chrome, Safari */
                }
                .hide-scrollbar {
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;     /* Firefox */
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>

            {/* Mobile-only fixed bottom invoice bar (delivered orders) */}
            {orderData?.status === 'DELIVERED' &&
              orderData?.orderType == null &&
              orderData?.returnId == null && (
                <div className="od-invoice-bar">
                    <button
                        type="button"
                        className="od-invoice-btn-m"
                        onClick={handleDownloadVendorInvoice}
                        disabled={downloadVendorInvoice}
                    >
                        {downloadVendorInvoice ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" />
                                <span>Downloading…</span>
                            </>
                        ) : (
                            <>
                                <FaDownload size={12} />
                                <span>Vendor invoice</span>
                            </>
                        )}
                    </button>
                    <button
                        type="button"
                        className="od-invoice-btn-m od-invoice-btn-m-primary"
                        onClick={handleDownloadCustomerInvoice}
                        disabled={downloadCustomerInvoice}
                    >
                        {downloadCustomerInvoice ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" />
                                <span>Downloading…</span>
                            </>
                        ) : (
                            <>
                                <FaDownload size={12} />
                                <span>Customer invoice</span>
                            </>
                        )}
                    </button>
                </div>
            )}

        </>
    )
}




export default OrderDetails